var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconPdf24 = function SvgAIconPdf24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 23H2.46667C1.65665 23 1 22.3433 1 21.5333V2.46667C1 1.65665 1.65665 1 2.46667 1H12.8595C13.2487 1.00008 13.6219 1.15485 13.8969 1.43022L19.6374 7.17076C19.9124 7.44594 20.0668 7.81913 20.0667 8.20818V12",
    stroke: "#005EB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0665 8.33333H14.1998C13.3898 8.33333 12.7332 7.67668 12.7332 6.86667V1",
    stroke: "#005EB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 23.0013V15.668",
    stroke: "#005EB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 15.668H9.07025C10.2853 15.668 11.2703 16.6529 11.2703 17.868C11.2703 19.083 10.2853 20.068 9.07025 20.068H8.33692",
    stroke: "#005EB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1995 23.0013C15.8195 23.0013 17.1328 21.688 17.1328 20.068V18.6013C17.1328 16.9813 15.8195 15.668 14.1995 15.668V23.0013Z",
    stroke: "#005EB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0662 23.0013V17.1346C20.0662 16.3246 20.7228 15.668 21.5328 15.668H22.9995",
    stroke: "#005EB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0662 20.0664H22.2662",
    stroke: "#005EB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconPdf24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMTI1IDIzSDIuNDY2NjdDMS42NTY2NSAyMyAxIDIyLjM0MzMgMSAyMS41MzMzVjIuNDY2NjdDMSAxLjY1NjY1IDEuNjU2NjUgMSAyLjQ2NjY3IDFIMTIuODU5NUMxMy4yNDg3IDEuMDAwMDggMTMuNjIxOSAxLjE1NDg1IDEzLjg5NjkgMS40MzAyMkwxOS42Mzc0IDcuMTcwNzZDMTkuOTEyNCA3LjQ0NTk0IDIwLjA2NjggNy44MTkxMyAyMC4wNjY3IDguMjA4MThWMTIiIHN0cm9rZT0iIzAwNUVCOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAuMDY2NSA4LjMzMzMzSDE0LjE5OThDMTMuMzg5OCA4LjMzMzMzIDEyLjczMzIgNy42NzY2OCAxMi43MzMyIDYuODY2NjdWMSIgc3Ryb2tlPSIjMDA1RUI4IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04LjMzMzAxIDIzLjAwMTNWMTUuNjY4IiBzdHJva2U9IiMwMDVFQjgiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguMzMzMDEgMTUuNjY4SDkuMDcwMjVDMTAuMjg1MyAxNS42NjggMTEuMjcwMyAxNi42NTI5IDExLjI3MDMgMTcuODY4QzExLjI3MDMgMTkuMDgzIDEwLjI4NTMgMjAuMDY4IDkuMDcwMjUgMjAuMDY4SDguMzM2OTIiIHN0cm9rZT0iIzAwNUVCOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjE5OTUgMjMuMDAxM0MxNS44MTk1IDIzLjAwMTMgMTcuMTMyOCAyMS42ODggMTcuMTMyOCAyMC4wNjhWMTguNjAxM0MxNy4xMzI4IDE2Ljk4MTMgMTUuODE5NSAxNS42NjggMTQuMTk5NSAxNS42NjhWMjMuMDAxM1oiIHN0cm9rZT0iIzAwNUVCOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAuMDY2MiAyMy4wMDEzVjE3LjEzNDZDMjAuMDY2MiAxNi4zMjQ2IDIwLjcyMjggMTUuNjY4IDIxLjUzMjggMTUuNjY4SDIyLjk5OTUiIHN0cm9rZT0iIzAwNUVCOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAuMDY2MiAyMC4wNjY0SDIyLjI2NjIiIHN0cm9rZT0iIzAwNUVCOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";